import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

export type Zone = components['schemas']['Zone']
export type ZonesResponse = components['schemas']['ZonesResponse']
export type PolygonGeometry = components['schemas']['PolygonGeometry']
export type ZoneGeometry = components['schemas']['ZoneGeometry']

export function useZones(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.zones.all,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/zones')
      if (error) throw error
      return data
    },
    staleTime: 24 * 60 * 60 * 1000, // 24 hours - zones rarely change
    enabled: options?.enabled ?? true,
  })
}
